import React from 'react';
import { connect } from "react-redux";

const CentralHubJobBoardNotification = (props) => {

  const {notificationsCount, notificationsReceived} = props;

  if (!notificationsReceived) {
    return null
  }

  return <div className="central-hub-badge bg-green central-hub-badge--job-board">{notificationsCount}</div>
};

const mapStateToProps = (store) => {
  return {
    notificationsCount: store.dashboardState.notificationsCount,
    notificationsReceived: store.dashboardState.notificationsReceived,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CentralHubJobBoardNotification);
